<template>
  <b-pagination-nav v-bind:link-gen="page_link"
                    v-bind:number-of-pages="number_of_pages"
                    v-on:change="scroll_to_top()"
                    use-router/>
</template>

<script>
import config from '../../config'

function get_total_accounts(vue){
  vue.$http.get(config.DATA_URI + "/accounts/total")
           .then(function(response){
               vue.total_accounts = parseInt(response["body"]);

           // on fail try again
           }, function(){
             setTimeout(function(){ get_total_accounts(vue); },
                        config.RETRY_SECONDS * 1000);
           });
}

export default {
  name: 'AccountDirNav',

  data : function(){
    return { total_accounts : 100000 };
  },

  computed : {
    number_of_pages : function(){
      var n = Math.ceil(this.total_accounts / this.$store.state.account.num_per_page);
      if(n < 1) return 1;
      return n;
    }
  },

  methods : {
    page_link : function(n){
      return n == 1 ? "/accounts" : ('/accounts/' + n);
    },

    scroll_to_top : function(){
      window.scrollTo(0,0);
    }
  },

  created : function(){
    get_total_accounts(this);
  }
}
</script>

<style scoped>
nav {
  display: inline-block;
}
</style>
